import { SupportedTokenName } from "@mezo/sdk"
import { Address } from "viem"

export type SwappableToken = Extract<
  SupportedTokenName,
  "MUSD" | "mBTC" | "mUSDT" | "mUSDC" | "mUSDe"
>
export enum SwapSettingsView {
  ASSET_SELECTOR = "swap-asset-selector",
  SLIPPAGE = "swap-slippage",
}

export enum SwapFormField {
  TOKEN_IN = "tokenIn",
  TOKEN_OUT = "tokenOut",
}

export enum SwapSlippageError {
  INVALID = "Invalid slippage percentage",
  TOO_SMALL = "Your slippage setting might be too tight for this trade to go through. You can increase it to help the transaction succeed.",
}

export type SwapFromFieldData = {
  amount: string
  token: SwappableToken
}

export type SwapFormValue = {
  [SwapFormField.TOKEN_IN]: SwapFromFieldData
  [SwapFormField.TOKEN_OUT]: SwapFromFieldData
  slippage: string
  transactionHash: `0x${string}` | null
}

export type SwapRoute = {
  from: Address
  to: Address
  stable: boolean
  factory: Address
}
